var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.348,
    height: 12.141,
    viewBox: "0 0 11.348 12.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "double-chevron-right",
    d: "M-4.539-11.211,1.176-5.469a.256.256,0,0,1,0,.438L-4.539.711A.3.3,0,0,1-5,.711L-5.551.164a.281.281,0,0,1,0-.465L-.6-5.25-5.551-10.2a.281.281,0,0,1,0-.465L-5-11.211A.3.3,0,0,1-4.539-11.211Zm3.91,0a.3.3,0,0,1,.465,0L5.551-5.469a.256.256,0,0,1,0,.438L-.164.711a.3.3,0,0,1-.465,0L-1.176.164a.281.281,0,0,1,0-.465L3.773-5.25-1.176-10.2a.281.281,0,0,1,0-.465Z",
    transform: "translate(5.674 11.32)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevronRight);
export default __webpack_public_path__ + "static/media/double-chevron-right.ad186e6d08e119a08a3f51c0dd49443c.svg";
export { ForwardRef as ReactComponent };